import type { Language } from './types';

/**
 * Safely access a local copy object with fallback to English.
 * Use this in components that maintain their own local copy dictionaries.
 * 
 * Example:
 * ```ts
 * const copy = { en: { title: 'Hello' }, es: { title: 'Hola' } };
 * const t = lc(copy, language); // falls back to en for unsupported languages
 * ```
 */
export function lc<T>(copy: { en: T } & Record<string, T>, lang: Language): T {
  return copy[lang] ?? copy.en;
}
